import React, { Component, useEffect, useState } from "react";

//custom
import { Link } from "react-router-dom";
import axios from "axios";

//utils
import {
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";

function AdminMenu() {
  //temp variable
  const [list_temp_load, set_list_temp_load] = useState([]);

  //myadmin variable
  const [is_admin, set_is_admin] = useState("no");

  //alert(is_admin_return);
  //starting on mount
  useEffect(() => {
    //isloginuser
    if (isloginuser()) {
      check_is_admin();
    }
  }, [list_temp_load]);

  //check user admin or not
  function check_is_admin() {
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    // Send formData object
    axios
      .post(CallURL.isadmin, formData)
      .then((response) => {
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "yes") {
          set_is_admin("yes");
        } else {
          set_is_admin("no");
        }
      })
      .catch((error) => {
        console.log(error);
        set_is_admin("no");
      });
  }
  function showmyadmin() {
    if (is_admin == "yes") {
      return (
        <div className="container">
          <div className="row">
            <div className="col s12 m12 l12"></div>
            <div className="col s12 m12 l12 app_view_contain_remove">
              <center>
                <font className="font_sub_title">Admin Menu</font>
                <hr />
                <br />
                <Link to={"/admin/manageuser"}>
                  <div className="font_sub_small_title div_but div_red center">
                    Manage User
                  </div>
                </Link>
              </center>
            </div>
          </div>
        </div>
      );
    }
  }

  return <React.Fragment>{showmyadmin()}</React.Fragment>;
}

export default AdminMenu;
